import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsAccountingTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader tabName={t('pageIntegrations.tabNames.accounting')} />
      <IntegrationsTable category={IntegrationCategory.ACCOUNTING} />
    </section>
  );
};

export default IntegrationsAccountingTab;
